export const COOKIE_CONSENT_KEY = "pediloo-cookie-consent"

export type CookieConsentStatus = "accepted" | "rejected" | null

export function readCookieConsent(storage: Pick<Storage, "getItem"> | null): CookieConsentStatus {
  if (!storage) return null
  const raw = storage.getItem(COOKIE_CONSENT_KEY)
  return raw === "accepted" || raw === "rejected" ? raw : null
}

export function writeCookieConsent(
  status: "accepted" | "rejected",
  storage: Pick<Storage, "setItem"> | null
): void {
  if (!storage) return
  storage.setItem(COOKIE_CONSENT_KEY, status)
}
